import { ChangeDetectorRef, Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BaseFormComponent } from 'projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component';
import { SelectorService } from 'projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service';
import { HttpCommonService } from 'projects/sepidz-web-framework/src/lib/services';

@Component({
  selector: 'ngx-preparation-delivery-time-form',
  templateUrl: './preparation-delivery-time-form.component.html',
  styleUrls: ['./preparation-delivery-time-form.component.scss']
})
export class PreparationDeliveryTimeFormComponent extends BaseFormComponent<any> {
  constructor(protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    public httpCommonService: HttpCommonService) {
    super(selectorService, cd);
  }
  formGroup: FormGroup = new FormGroup({
    PreprationDeliveryTime: new FormControl(null),
  });
  async save() {
    if (this.submitButtonDisabled())
      return;
    this.result = this.formGroup.controls['PreprationDeliveryTime'].value;
    this.close();
  }
  submitButtonDisabled(): boolean {
    if (!this.formGroup.controls['PreprationDeliveryTime'].value) {
      this.isSaved = false;
      return true;
    }
    else {
      this.isSaved = true;
      return false;
    }
  }
}
